const Heart = () => (
  <>
    <path
      fill="currentColor"
      d="M11.98 19.094q-.292 0-.577-.106a1.4 1.4 0 0 1-.503-.322l-1.148-1.037q-2.67-2.425-4.71-4.717Q3 10.622 3 8.15q0-1.908 1.296-3.204T7.5 3.65q1.095 0 2.279.553 1.185.553 2.221 2.086 1.036-1.533 2.221-2.086T16.5 3.65q1.908 0 3.204 1.296T21 8.15q0 2.529-2.125 4.861a69 69 0 0 1-4.652 4.624l-1.142 1.03a1.4 1.4 0 0 1-.513.323q-.295.106-.587.106m-.469-11.767q-.897-1.448-1.867-2.062A3.9 3.9 0 0 0 7.5 4.65q-1.5 0-2.5 1t-1 2.5q0 1.108.627 2.272.627 1.165 1.684 2.386a32 32 0 0 0 2.428 2.498q1.372 1.276 2.857 2.629.174.154.404.154a.6.6 0 0 0 .404-.154q1.485-1.352 2.857-2.63a32 32 0 0 0 2.428-2.497q1.057-1.221 1.684-2.386Q20 9.258 20 8.15q0-1.5-1-2.5t-2.5-1q-1.175 0-2.144.615-.97.614-1.867 2.062a.5.5 0 0 1-.214.202.6.6 0 0 1-.275.067.6.6 0 0 1-.275-.067.5.5 0 0 1-.213-.202"
    />
  </>
)
export default Heart
